import React from 'react';
import { StyleSheet } from 'react-native';
import { FlatList } from 'react-native';
import { useTagsQuery } from '@annunciate/query';
import { TagListItem } from './TagListItem';
export const TagList = ({ item, }) => {
    const { data } = useTagsQuery();
    const renderItem = ({ item: tag }) => (React.createElement(TagListItem, { tag: tag, item: item }));
    if (!data || !data.length)
        return null;
    return (React.createElement(FlatList, { style: styles.listContainer, keyExtractor: (tag, index) => `${tag.id}-${index}`, data: data, renderItem: renderItem }));
};
const styles = StyleSheet.create({
    listContainer: {
        marginTop: 20,
        marginBottom: 50,
    },
});
//# sourceMappingURL=TagList.js.map